export default function (data) {
    switch(data) {
      case 'M': return '- Matutino';
      case 'V': return '- Vespertino';
      case 'N': return '- Noturno';
      case 'I': return '- Integral';
      default: return '';
    }
};